import { FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Div, Gutter, Headline, List, Link, BodyText } from '@gaiads/telia-react-component-library';
import { Trans, useTranslation } from 'react-i18next';

import { RootState } from '../../../store/reducers';
import { authSetSelectedOrganization, shopClearOrderOnBehalfUser } from '../../../store/actions';

const AdministratingOtherOrganization: FunctionComponent = () => {
  const ownOrganization = useSelector((state: RootState) => state.authentication.user?.organization);
  const selectedOrganization = useSelector((state: RootState) => state.authentication.selectedOrganization);

  const dispatch = useDispatch();

  const { t: tShop } = useTranslation('shop');
  const { t: tLayout } = useTranslation('layoutComponents');

  return (
    <Div margin={{ size: 'lg' }}>
      <Headline block size={'sm'}>
        <Trans
          t={tShop}
          i18nKey={'selectedOtherOrganization.infoText1'}
          values={{ selectedOrganizationName: selectedOrganization?.name }}
          shouldUnescape={true}
        />
      </Headline>
      <Gutter size={'md'} />
      <List disc>
        <List.Item>
          <Link to={'/users'}>{tLayout('Header.menuItems.usersAndOnboarding')}</Link>
        </List.Item>
        <List.Item>
          <Link to={'/organizationassets'}>{tLayout('Header.menuItems.devicesAndReports')}</Link>
        </List.Item>
        <List.Item>
          <Link to={'/onboarding/usergroups'}>{tLayout('Header.menuItems.groups')}</Link>
        </List.Item>
        <List.Item>
          <Link to={'/organization'}>{tLayout('Header.menuItems.companySettings')}</Link>
        </List.Item>
      </List>
      <Gutter size={'md'} />
      <Headline block size={'xs'}>
        <Trans
          t={tShop}
          i18nKey={'selectedOtherOrganization.infoText2'}
          components={{
            a1: (
              <BodyText
                tagName={'a'}
                clickableAppearance
                color={'purple500'}
                inlineBlock
                onClick={() => {
                  dispatch(shopClearOrderOnBehalfUser());
                  dispatch(authSetSelectedOrganization(ownOrganization!));
                }}
              />
            ),
          }}
          values={{ ownOrganization: ownOrganization?.name }}
          shouldUnescape={true}
        />
      </Headline>
    </Div>
  );
};

export default AdministratingOtherOrganization;
